import stls from '@f_styles/general/Wrapper.module.sass';
import cn from 'classnames';
import { TypeChildren, TypeClassNames } from '@f_types/index';

type TypeWrapperProps = TypeClassNames & TypeChildren;

export function Wrapper({ classNames, children }: TypeWrapperProps) {
    return <div className={cn(stls.container, classNames)}>{children}</div>;
}
